import React, { useContext } from 'react';
import { TokenSessionManager } from '@lib/http';

export const SessionManagerContext = React.createContext<TokenSessionManager | null>(null);

export const useSessionManager = (): TokenSessionManager | null => useContext(SessionManagerContext);
